'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('@apollo/client');
var nthHookSettings = require('@narvar/nth-hook-settings');
var SessionContext = require('../../../common/providers/SessionContext.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const useTrackSettingsParameters = () => {
  const {
    retailerMoniker,
    versionName,
    localeCountry,
    localeLanguage,
    cache
  } = SessionContext.useSession();
  return {
    product: 'narvarjs',
    retailerMoniker,
    versionName,
    localeLanguage,
    localeCountry,
    cache
  };
};

// Some retailer settings used for assist will be pulled from both the track (narvarjs) product as well
// as the assist (claims) product. This hook fetches those settings for the cache, and can
// be used in the PrefetchData component combine the query with the others that run on page load
const useTrackSettings = () => {
  const client$1 = client.useApolloClient();
  const parameters = useTrackSettingsParameters();
  return client.useQuery(nthHookSettings.retailerSettingsQuery(`
    globalScopeCSS
    trackHeader {
      html
      querySelectors
      sticky
    }
  `), {
    client: client$1,
    variables: parameters
  });
};
const LomaTrackSettingsProvider = _ref => {
  let {
    children
  } = _ref;
  const parameters = useTrackSettingsParameters();
  return /*#__PURE__*/React__default["default"].createElement(nthHookSettings.LomaSettingsConfigProvider, parameters, children);
};

exports.LomaTrackSettingsProvider = LomaTrackSettingsProvider;
exports.useTrackSettings = useTrackSettings;
